/**
 * Stub for @react-native-firebase/remote-config/lib/modular - web build only.
 */
const noop = () => {};
const noopAsync = () => Promise.resolve();

module.exports = {
    getRemoteConfig: noop,
    setDefaults: noop,
    fetch: noopAsync,
    fetchAndActivate: noopAsync,
    getAll: noopAsync,
};
